// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Input_componentWrapper__LO0HJ","error":"Input_error__SdyL7"};